import { useEffect, useRef, useState } from 'react';
import { styled } from 'styled-components';

import { useCaseListContext } from '../../../../shared/context/CaseListContext';

export const StyledImage = styled.img<{
  $width?: string;
  $height?: string;
}>`
  max-width: 100%;
  width: ${p => p.$width ?? 'fit-content'};
  height: ${p => p.$height ?? 'fit-content'};
  object-fit: cover;
`;

interface ImageViewProps {
  imageId: string;
  width?: string;
  height?: string;
}
export const ImageView = (props: ImageViewProps) => {
  const { imageId, width, height } = props;
  const [reader] = useState(new FileReader());
  const { useDicomImage } = useCaseListContext();
  const { data: source } = useDicomImage(imageId);

  const ref = useRef<HTMLImageElement | null>(null);
  useEffect(() => {
    function onLoad() {
      if (ref.current) {
        ref.current.src = reader.result as string;
      }
    }
    reader.addEventListener('load', onLoad);
    if (source) {
      reader.abort();
      reader.readAsDataURL(source);
    }
    return () => reader.removeEventListener('load', onLoad);
  }, [reader, source, imageId]);

  return <StyledImage ref={ref} $width={width} $height={height} />;
};
